/**
 * Primary front-end script.
 *
 * @package   RSClassic
 * @author    RedAct Solutions Ltd <info@redactsolutions.co.uk>
 * @link      https://www.redactsolutions.co.uk
 * @license   GPL-2.0-or-later
 */

import {allyToggle} from './menu/a11y-toggle';

/**
 * @return void
 */
(function () {
	'use strict';

	// Common.
	let app = document.getElementById('App');
	let appHeader = document.getElementById('appHeader');
	let appFooter = document.getElementById('appFooter');
	let appMain = document.getElementById('appMain');

	// Scroll to top.
	let scrollToTopOffset = 100;

	// Responsive menu.
	let menuToggle = document.getElementById('menuToggle');

	ready(function () {
		columnCollapseTables();
		disableLightbox();
	});

	window.onscroll = function () {
		scrollToTop();
	};

	// Scroll to top.
	function scrollToTop() {
		if (window.pageYOffset >= scrollToTopOffset) {
			document.getElementById('backToTop').style.display = 'block';
		} else {
			document.getElementById('backToTop').style.display = 'none';
		}
	}

	// Responsive menu.
	function toggleDropDownMenu() {
		app.classList.toggle('drop-down-open');
	}

	menuToggle.addEventListener('click', toggleDropDownMenu);

	function closeDropDownMenu() {
		app.classList.remove('drop-down-open');
	}

	/** Need better solution i.e. click anywhere outside navigation div **/
	//appHeader.addEventListener('click', closeDropDownMenu);
	appFooter.addEventListener('click', closeDropDownMenu);
	appMain.addEventListener('click', closeDropDownMenu);

	// Responsive column collapse tables.
	function columnCollapseTables() {

		let table = document.querySelectorAll('.col-collapse');
		let tablebody = document.querySelectorAll('.col-collapse tbody');
		let headertext = [];
		let headrow;
		let current;
		let tbody;
		let row;
		let col;
		let h;
		let i;
		let j;

		for (i = 0; i < table.length; i++) {
			headertext[i] = [];

			// eslint-disable-next-line no-cond-assign
			for (j = 0, headrow; headrow = table[i].rows[0].cells[j]; j++) {
				current = headrow;
				headertext[i].push(current.textContent.replace(/\r?\n|\r/, ''));
			}
		}

		if (0 < table.length) {
			// eslint-disable-next-line no-cond-assign
			for (h = 0, tbody; tbody = tablebody[h]; h++) {
				// eslint-disable-next-line no-cond-assign
				for (i = 0, row; row = tbody.rows[i]; i++) {
					// eslint-disable-next-line no-cond-assign
					for (j = 0, col; col = row.cells[j]; j++) {
						col.setAttribute('data-th', headertext[h][j]);
					}
				}
			}
		}
	}

	function ready(callbackFunc) {
		if ('loading' !== document.readyState) {

			// Document is already ready, call the callback directly
			callbackFunc();
		} else if (document.addEventListener) {

			// All modern browsers to register DOMContentLoaded
			document.addEventListener('DOMContentLoaded', callbackFunc);
		} else {

			// Old IE browsers
			document.attachEvent('onreadystatechange', function () {
				if ('complete' === document.readyState) {
					callbackFunc();
				}
			});
		}
	}

	// Disables Featherlight lightbox on any links with 'disable-lightbox' class.
	function disableLightbox() {
		let elements = document.getElementsByClassName('disable-lightbox');

		for (let i = 0; i < elements.length; i++) {
			elements[i].removeAttribute('data-featherlight');
		}
	}

})();
